import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineDot from '@mui/lab/TimelineDot';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import Typography from '@mui/material/Typography';
import {Chip, Popover} from "@mui/material";
import {green, red} from "@mui/material/colors"
import {useState} from "react";

/**
 * Operations with more arrays, this one returns either the object or the number
 * with their previous validation
 * @param points
 * @param unit_id
 * @param type
 * @returns {number|*}
 */
const getUnitNumberFromUnitIdWithPoints = (points, unit_id, type = 'number') => {
    const point = points.find(point => {
        return point.unit_id === unit_id
    });

    if (type === 'number') {
        return parseInt(point?.unit_number);
    }

    return point;
}

function TimeLine({stations, units, orientation, points}) {

    const objOfUnits = [];

    units.map((unit, id) => {
        objOfUnits.push({
            unit_id: id,
            meters: unit[0],
            station_id: unit[1],
            orientation: orientation[id]
        });
    })

    const triangleUp = () => <Typography>&#9650;</Typography>;
    const triangleDown = () => <Typography>&#9660;</Typography>

    const [anchorEl, setAnchorEl] = useState(null);
    const [point, setPoint] = useState({});

    const handleClick = (event, unit_id) => {
        setAnchorEl(event.currentTarget);
        setPoint(getUnitNumberFromUnitIdWithPoints(points, unit_id, 'object'));
    };

    const handleClose = () => {
        setAnchorEl(null);
        setPoint({});
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <>
            <Timeline>
                {stations && stations.map((station, i) => {

                    const unitsHere = objOfUnits.filter((unit, id) => {
                        const {station_id} = unit;
                        return station_id === station.id;
                    });

                    return (
                        <TimelineItem key={i}>
                            <TimelineOppositeContent
                                sx={{m: 'auto 0'}}
                                align="right"
                                variant="body2"
                                color="text.secondary"
                            >
                                {unitsHere && unitsHere.map(({unit_id, orientation}, i) => (
                                    <Chip key={i} aria-describedby={id} onClick={(e) => handleClick(e, unit_id)}
                                          label={
                                              <Typography
                                              sx={{display: "flex"}}>{getUnitNumberFromUnitIdWithPoints(points, unit_id)} {station.id !== 20 ? (orientation > 0 ? triangleUp() : triangleDown()) : ""}
                                              </Typography>
                                          }
                                          size="small"
                                          sx={{borderColor: orientation > 0 ? green["600"] : red["600"], m: 0.5}}
                                          variant="outlined"/>
                                ))}
                            </TimelineOppositeContent>
                            <TimelineSeparator>
                                <TimelineConnector/>
                                <TimelineDot color="grey" variant="outlined">
                                    <MyLocationIcon></MyLocationIcon>
                                </TimelineDot>
                                <TimelineConnector/>
                            </TimelineSeparator>
                            <TimelineContent sx={{py: '12px', px: 2}}>
                                <Typography variant="h6" component="span">
                                    {station.name}
                                </Typography>
                                <Typography> {station.id} </Typography>
                            </TimelineContent>
                        </TimelineItem>
                    )
                })}
            </Timeline>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                {
                    point && Object.keys(point) && (
                        <>
                            <Typography sx={{px: 2, pt: 2}} fontWeight="bold">Datos actuales
                                ({point.unit_number}): </Typography>
                            <Typography sx={{px: 2, pb: 2}}>
                                ConteosFrente: {point.cf} <br/>
                                BloqueoFrente: {point.bf} min.<br/>
                                AuxFrente: {point.af} <br/>
                                ConteosAtrás: {point.cb} <br/>
                                BloqueoAtrás: {point.bb} min.<br/>
                                AuxAtrás: {point.ab} <br/>
                            </Typography>
                        </>
                    )
                }
            </Popover>
        </>
    );
}

export default TimeLine